import React, { useMemo } from 'react';
import { Map, TileLayer, CircleMarker, Popup } from 'react-leaflet';
import { Row } from 'reactstrap';

import 'leaflet/dist/leaflet.css';

function readLng(location) {
    if (!location) {
        return null;
    }
    if (location.longitude != null && location.longitude !== '') {
        return Number(location.longitude);
    }
    if (location.longtitude != null && location.longtitude !== '') {
        return Number(location.longtitude);
    }
    return null;
}

function DashboardMap(props) {
    const points = useMemo(() => {
        const markerList = Array.isArray(props.marker) ? props.marker : [];
        return markerList
            .map((item) => {
                if (!item.location || item.location.latitude == null) {
                    return null;
                }
                const lat = Number(item.location.latitude);
                const lng = readLng(item.location);
                if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
                    return null;
                }
                return {
                    lat,
                    lng,
                    name: item.player_name || item.player_id || 'Screen',
                };
            })
            .filter(Boolean);
    }, [props.marker]);

    const center = useMemo(() => {
        if (!points.length) {
            return [-1.286389, 36.817223];
        }
        const sum = points.reduce(
            (acc, p) => ({ lat: acc.lat + p.lat, lng: acc.lng + p.lng }),
            { lat: 0, lng: 0 },
        );
        return [sum.lat / points.length, sum.lng / points.length];
    }, [points]);

    const zoom = points.length === 0 ? 6 : points.length === 1 ? 11 : 6;

    return (
        <Row className="w-100">
            <div className="w-100 rounded overflow-hidden border" style={{ height: '420px' }}>
                <Map center={center} zoom={zoom} style={{ height: '100%', width: '100%' }} className="map">
                    <TileLayer
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    {points.map((p, index) => (
                        <CircleMarker
                            key={`${p.lat}-${p.lng}-${index}`}
                            center={[p.lat, p.lng]}
                            radius={10}
                            color="#5a33e4"
                            fillColor="#5a33e4"
                            fillOpacity={0.85}
                            weight={2}
                        >
                            <Popup>{p.name}</Popup>
                        </CircleMarker>
                    ))}
                </Map>
            </div>
        </Row>
    );
}

export default DashboardMap;
